import { render, staticRenderFns } from "./MgrEditor.vue?vue&type=template&id=33f76907&scoped=true"
import script from "./MgrEditor.vue?vue&type=script&lang=js"
export * from "./MgrEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f76907",
  null
  
)

export default component.exports